import React from 'react';

import { ICONS } from 'shared/presentation/constants';
import {
  TRoutePathsWithParams,
  useLocale,
  useNavigation,
} from 'shared/presentation/contexts';

import * as S from './styles';

const BackIcon = ICONS.ARROW_LEFT;

interface IBackButtonProps {
  text?: string;
  to?: TRoutePathsWithParams;
  onClick?: () => void;
  disabled?: boolean;
}

const BackButton: React.FC<IBackButtonProps> = ({
  text,
  to,
  onClick,
  disabled,
}) => {
  const navigation = useNavigation();
  const { t } = useLocale('customer');

  const handleGoBack = () => {
    if (disabled) return;

    onClick?.();

    if (to) return navigation.replace(to);

    return navigation.goBack();
  };

  return (
    <S.Container onClick={handleGoBack} disabled={disabled}>
      <BackIcon />

      <span>{text || t('Back')}</span>
    </S.Container>
  );
};

export default BackButton;
